<template>
    <div id="siteframe">
    <!-- content -->
        <div id="content">
            <div id="_page_content">
                <div class="column_100">
                    <div id="main" min_height="400" style="; width: 100%">
                        <div>
                            <div class="heroband" style="background: #1e2338 url(/static/images/hero-demo.png) center center no-repeat; background-size: cover;">
                                <h1>Free Demo</h1>
                                <p style="color:white !important;">Fill out the form below to request a free demo.</p>
                                    <button type="button" class="button" data-toggle="modal" data-src="https://www.youtube.com/embed/Jfrjeg26Cwk" data-target="#myModal" @click="identified=false;">
                                        Watch a Recorded Demo Now
                                    </button>
                                    <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                            <div class="modal-dialog" role="document">
                                                <div class="modal-content">

                                                
                                                <div class="modal-body">

                                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                    </button>        
                                                    <!-- 16:9 aspect ratio -->
                                                    <div class="embed-responsive embed-responsive-16by9" v-if="identified">
                                                        <iframe width="560" height="315" src="https://www.youtube.com/embed/CqKZotsmrcw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                                    </div>
                                                    <div v-else>
                                                        <form class="form">
                                                            <h3>Before We Begin</h3>
                                                            <hr>
                                                            <label for="name" class="float-left" style="float:left;">What's your name?</label>
                                                            <input type="text" class="form-control" id="name" placeholder="Name" v-model="name" v-on:keyup="updateOutputUrl">
                                                            <label for="contact" class="float-left" style="float:left;">How may we contact you?</label>
                                                            <input type="text" class="form-control" id="contact" aria-describedby="contactHelp" placeholder="Phone Number" v-model="contact" v-on:keyup="updateOutputUrl">
                                                            <label for="company" class="float-left" style="float:left;">What's your company's name?</label>
                                                            <input type="company" class="form-control" id="company" aria-describedby="companyHelp" placeholder="Company" v-model="company" v-on:keyup="updateOutputUrl">
                                                            <label for="company" class="text-left" style="margin-bottom: 25px;">&nbsp;</label>
                                                            <a v-bind:href="outputUrl" class="btn btn-info pull-left" style="margin-top:10px;">Submit</a>
                                                            <button @click.prevent="setIdentified" style="position:fixed; right:40px; bottom:10px; cursor:pointer; color:grey;background-color:white;">Just show me the video</button>
                                                        </form>
                                                    </div>                                                   
                                                    
                                                </div>

                                                </div>
                                            </div>
                                    </div> 
                                                                            
                            </div>
                             <!-- Button trigger modal -->

                        </div>
                        <div style="position: relative; margin: 0 auto; width: 800px; max-width: 90%; padding: 20px; background-color: #fff; border-radius: 10px; border: 0px solid #ccc; box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.25); margin-bottom: 10px; top: -20px;">
                                                        <form class="form">
                                                            <h3>Request a Free Trial</h3>
                                                            <hr>
                                                            <label for="name" class="float-left" style="float:left;">What's your name?</label>
                                                            <input type="text" class="form-control" id="name" placeholder="Name" v-model="name" v-on:keyup="updateOutputUrl">
                                                            <label for="contact" class="float-left" style="float:left;">How may we contact you?</label>
                                                            <input type="text" class="form-control" id="contact" aria-describedby="contactHelp" placeholder="Phone Number" v-model="contact" v-on:keyup="updateOutputUrl">
                                                            <label for="company" class="float-left" style="float:left;">What's your company's name?</label>
                                                            <input type="company" class="form-control" id="company" aria-describedby="companyHelp" placeholder="Company" v-model="company" v-on:keyup="updateOutputUrl">
                                                            <label for="company" class="text-left" style="margin-bottom: 25px;">&nbsp;</label>
                                                            <a v-bind:href="outputUrl" class="btn btn-info pull-left" style="margin-top:10px;color:white;">Submit Request</a>
                                                        </form>   
                        </div>

                    </div>
                    <div style="clear: both;"></div>
                </div>		
                <div style="clear: both;"></div>
            </div>
    <!-- end content -->	
        </div>
    </div>
</template>

<script>
	import {EventBus} from '../event-bus.js'

    export default {
        name: 'free-demo',
        data () {
            return {
                outputUrl: null,
                identified: false,
                emailTo: 'info@infinittna.com',
                email: {
                    subject: '[IBA] Infinitt Business Analytics Demo',
                    cc: '',
                    bcc: '',
                    body: '',
                },
                contact: null,
                name: null,
                company: null,
            }
        },
        mounted(){

        },
        methods: {
            showNoty: function(){
                EventBus.$emit('noty', {type:'success',msg:'hurray!'});
            },
            updateOutputUrl: function() {
                this.identified = true;
                this.outputUrl = "mailto:" + this.emailTo;
                this.email.body = `Name: ${this.name || ''}\nContact: ${this.contact || ''}\nCompany: ${this.company || ''}\n`;
                const emailKeys = Object.keys(this.email);
                const remaining = emailKeys.filter(
                    (key) => this.email[key].trim().length > 0
                );
                if (remaining.length > 0) {
                    this.outputUrl += "?";
                }
                this.outputUrl += remaining
                    .map((key) => `${key}=${encodeURI(this.email[key].trim())}`)
                    .join("&");
            },
            setIdentified: function(event) {
                this.identified = true;
            },
            sendEmail: function(event){
                this.identified = true;
                const data = {
                    source: 'Watch a Recorded Demo Now Button',
                    email: this.email,
                    name: this.name,
                    company: this.company,
                }
                fetch('/email', {
                        method: 'POST',
                        body: JSON.stringify(data),
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }).then(function(response) {

                    }).then(function(data) {
                });

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/js/components/FreeDemo.vue